export default "__VITE_ASSET__CXZ8xhTg__"